/**
 * index.tsx
 *
 * This is the entry file for the application
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

// Use consistent styling
// import 'sanitize.css/sanitize.css';

// Import root app
import { App } from 'core';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'controller/store/configureStore';

import reportWebVitals from 'reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css';

// Initialize languages
import './controller/locales/i18n';
import ExternalTemplateLoader from 'features/LandingPage/DesktopComponents/ExternalTemplateLoader';
import Modal from 'react-modal';
import TroubleshootingWrapper from "core/components/TroubleshootingWrapper";
import { getCurrentHostContext } from 'core/utils/hostname';

const store = configureAppStore();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const currentPath = window.location.pathname;
const hostContext = getCurrentHostContext();
const shouldRenderSchoolWebsite =
  hostContext.type === 'school' && currentPath === '/';

// Set app element for accessibility
Modal.setAppElement('#root');

root.render(
  <TroubleshootingWrapper>
    <Provider store={store}>
      <HelmetProvider>
        {/* <React.StrictMode> */}
        {shouldRenderSchoolWebsite ? <ExternalTemplateLoader /> : <App />}
        <ToastContainer />
        {/* </React.StrictMode> */}
      </HelmetProvider>
    </Provider>
  </TroubleshootingWrapper>
);

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./controller/locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
